import { Button, CircularProgress } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteForever from "@material-ui/icons/DeleteForever";
import FileIcon from '@material-ui/icons/AttachFile';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ShowIcon from '@material-ui/icons/List';
import RestoreIcon from '@material-ui/icons/Restore';
//import { Markup } from 'interweave';
import _ from 'lodash';
import React, { lazy, Suspense } from "react";
import { Link, Route } from "react-router-dom";
import { AppConfig } from "../../../config/app";
import { DataApi } from "../../../providers/api-provider";
import GlobalStore from "../../../providers/global-store-provider";
import ShowIfRole from "./ShowIfRole";
//import TextareaShow from "./TextareaShow";

const Markup = lazy(() => import('interweave'));
const TextareaShow = lazy(() => import('./TextareaShow'));




/*
-----------------------------------------------------------------------
Helper File (frequently used standalone functions or components)
-----------------------------------------------------------------------
*/
/* Hanle State Management of form */
export async function handleInputState(event) {
  // taken straight from the official React Docs
  // https://reactjs.org/docs/forms.html#handling-multiple-inputs
  const target = event.target;
  const value = target.type === "checkbox"
    ? target.checked
    : target.value;
  const name = target.name;
  let { errors, form, render } = this.state;
  if (errors && typeof (errors[name]) !== 'undefined')
    errors[name] = value ? value.length === 0 : true;
  if (typeof (form) === 'undefined') {
    this.setState({
      [name]: value,
      errors: errors
    });
  }
  else {
    form[name] = value;
    this.setState({
      form: form,
      errors: errors
    });
    //Fire change event for parent
    if (render && render[name] && typeof (render[name].onChangeEventForParent) === 'function')
      render[name].onChangeEventForParent(value);
    return { name, value, render }
  }

};
//Simple Input State management handler
export function simpleInputStateHandler(name) {
  return event => {
    const target = event.target;
    const value = target.type === "checkbox"
      ? target.checked
      : target.value;
    this.setState({ [event.target.name ? event.target.name : name]: value, });
  }
};
//Simple Input State management handler
export function simpleInputStateHandlerInForm(name) {
  return event => {
    const target = event.target;
    const value = target.type === "checkbox"
      ? target.checked
      : target.value;
    const form = this.state.form;
    form[event.target.name ? event.target.name : name] = value;
    this.setState(form);
  }
};
//Simple Input State management handler
export function simpleInputStateHandlerInPath(path, name) {
  return event => {
    const target = event.target;
    const value = target.type === "checkbox"
      ? target.checked
      : target.value;
    const newPath = this.state[path];
    newPath[event.target.name ? event.target.name : name] = value;
    this.setState({ [path]: newPath });
  }
};
//Update State on Prop Change
export function handleStateChangeFromProps(nextProps, prevState) {
  let newState = {}
  let changed = false;
  for (let prop in nextProps)
    if (nextProps[prop] !== prevState[prop]) {
      newState[prop] = nextProps[prop];
      changed = true;
    }
  return changed ? newState : null
}
//Layout & Screen Component Route
export const AppRoute = ({ component: Component, layout: Layout, title, ...rest }) => (
  <Route {...rest} render={props => (
    <Layout title={title}>
      {Component && <Component {...props} />}
    </Layout>
  )} />
)
//ResourceRoute
export const ResourceRoute = ({ key, base, entity, layout: Layout, title, grid: Grid, create: Create, show: Show, edit: Edit, pluralTitle, ...rest }) => {
  return [
    AppRoute({ key: 'view' + key, exact: true, path: "/" + (base ? base + "/" : '') + entity, layout: Layout, component: Grid, title: pluralTitle ? pluralTitle : title + 's' }),
    Create ? AppRoute({ key: 'create' + key, exact: true, path: "/" + (base ? base + "/" : '') + entity + "/create", layout: Layout, component: Create, title: 'Create ' + title }) : '',
    Edit ? AppRoute({ key: 'edit' + key, exact: true, path: "/" + (base ? base + "/" : '') + entity + "/:id/edit", layout: Layout, component: Edit, title: 'Edit ' + title }) : '',
    Show ? AppRoute({ key: 'show' + key, exact: true, path: "/" + (base ? base + "/" : '') + entity + "/:id/show", layout: Layout, component: Show, title: 'Show ' + title }) : '',
  ]
}
//Grid Actions
export const GridEditButton = (base, entity, id, entityTitle) => (
  <Tooltip key={1} title={"Edit " + (entityTitle || "")} placement="top">
    <Button component={Link} to={"/" + (base ? base + "/" : "") + entity + "/" + id + '/edit'} variant="outlined" className='lrmargin-xs' size="small"  ><EditIcon color="inherit" /></Button>
  </Tooltip>
)
export const GridShowButton = (base, entity, id, entityTitle) => (
  <Tooltip key={3} title={"View " + (entityTitle || "")} placement="top">
    <Button component={Link} to={"/" + base + "/" + entity + "/" + id + '/show'} variant="outlined" className='lrmargin-xs' size="small"  ><ShowIcon color="inherit" /></Button>
  </Tooltip>
)
export const GridDeleteButton = (showDeleteDialog, entityTitle, roles = ['super-admin', 'admin']) => (
  <ShowIfRole roles={roles}>
    <Tooltip key={2} title={"Delete " + (entityTitle || "")} placement="top">
      <Button onClick={() => showDeleteDialog()} variant="outlined" className='lrmargin-xs' size="small"  ><DeleteIcon color="error" /></Button>
    </Tooltip>
  </ShowIfRole>
)
export const GridDeletePermanentlyButton = (showDeleteDialog, entityTitle) => (
  <ShowIfRole roles={['super-admin']}>
    <Tooltip key={6} title={"Delete " + (entityTitle || "") + " Permanently"} placement="top">
      <Button onClick={() => showDeleteDialog()} variant="outlined" className='lrmargin-xs' size="small"  ><DeleteForever color="error" /></Button>
    </Tooltip>
  </ShowIfRole>
)
export const GridCustomButton = (callback, Icon, title) => (
  <Tooltip key={4 + title} title={title} placement="top" >
    <Button onClick={callback} variant="outlined" className='lrmargin-xs' size="small"  ><Icon size={24} /></Button>
  </Tooltip >
)
export const GridRestoreButton = (callback, entityTitle) => (
  <Tooltip key={5} title={"Restore " + (entityTitle || "")} placement="top" >
    <Button onClick={callback} variant="outlined" className='lrmargin-xs' size="small"  ><RestoreIcon color="primary" /></Button>
  </Tooltip>
)
export const GridLinkButton = (url, entityTitle) => (
  url ?
    <Tooltip key={7} title={"Open " + (entityTitle || "")} placement="top" >
      <Button onClick={() => { let win = window.open(url, '_blank'); win.focus(); }} variant="outlined" className='lrmargin-xs' size="small"  ><FileIcon /></Button>
    </Tooltip> :
    <span key={7} />
)
//Grid Boolean Column
export const GridBooleanField = (title, accessor, positiveTitle, negativeTitle, width, notFilters, invert) => {

  return {
    Header: title || 'Active/Inactive',
    accessor: accessor || 'active',
    maxWidth: width || 110,
    width: width || 110,
    filterable: !notFilters,
    Cell: props => (invert ? !props.value : props.value) ? <CheckIcon color="primary" /> : <CloseIcon color="error" />,
    Filter: ({ filter, onChange }) =>
      <select
        onChange={event => onChange(event.target.value)}
        style={{ width: "100%" }}
        value={filter ? filter.value : "all"}
      >
        <option value="">Show All</option>
        <option value="1">{positiveTitle || 'Yes'}</option>
        <option value="0">{negativeTitle || 'No'}</option>
      </select>
  }
}
//Render String as HTML
export function renderStringAsHtml(stringHtml, useDraftJs = false) {
  stringHtml = stringHtml ? replaceAll(stringHtml, '&nbsp;', ' ') : '';
  if (useDraftJs)
    return <Suspense fallback={<Loader />}><TextareaShow value={stringHtml} /></Suspense>
  return <Suspense fallback={<Loader />}><Markup content={stringHtml} /></Suspense>
}

//Loader
export const Loader = function ({ size = '', color = '', style = {} }) {
  size = size || '40';
  const loaderStyle = { width: size + 'px', height: size + 'px', };
  if (color)
    loaderStyle.color = color;
  return (<div className='loader-container' style={{ ...style, width: size + 'px', height: size + 'px' }} ><CircularProgress style={loaderStyle} /></div>)
};
export function replaceAll(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}
export function showSuccess(message) {
  GlobalStore.snackbar.showSnakBar(message, 'success');
}
export function showWarning(message) {
  GlobalStore.snackbar.showSnakBar(message, 'warning');
}
export function showError(error) {
  if (typeof (error) === 'string') {
    GlobalStore.snackbar.showSnakBar(error, 'error', 10000);
    return error;
  }
  else {
    const message = error && typeof (error.response) !== 'undefined' ? error.response.data.message : 'Connection Error';
    GlobalStore.snackbar.showSnakBar(message, 'error', 10000);
    return message;
  }
}
export function formatCurrency(n, c, d, t) {
  c = isNaN(c = Math.abs(c)) ? 0 : c;
  d = d === undefined ? "." : d;
  t = t === undefined ? "," : t;
  var s = n < 0 ? "-" : "",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}
export function handleResponseErrors(res, fields) {
  if (!res.response || typeof (res.response.data.errors) === 'undefined') return { enabled: false };
  let errors = {};
  for (var field in fields) {
    if (!fields.hasOwnProperty(field))
      continue;
    errors[field] = typeof (res.response.data.errors[field]) !== "undefined" ? res.response.data.errors[field][0] : false;
  }
  errors.enabled = true;
  return errors;
}
export function calculateAmountWithStripeFees(amount, isAmEx) {
  if (isAmEx)
    return Number(+Math.round((amount + 0) / (1 - 3.5 / 100) + "e+2") + "e-2");
  return Number(+Math.round((amount + 0.3) / (1 - 2.2 / 100) + "e+2") + "e-2");
}
export function calculateTotalFees(amount) {
  if (!amount) return '';
  return Number(+Math.round((amount + 0) / (1 - AppConfig.fees / 100) + "e+2") + "e-2");
}
export function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
export function postMessageToParent(type, message) {
  if (!message) message = {};
  message.type = type;
  message.source = 'edseed';
  window.parent.postMessage(message, '*');
}
export function getCurrencyCodes() {
  return [{ "id": "AFN", "name": "AFN" }, { "id": "ALL", "name": "ALL" }, { "id": "AMD", "name": "AMD" }, { "id": "ANG", "name": "ANG" }, { "id": "AOA", "name": "AOA" }, { "id": "ARS", "name": "ARS" }, { "id": "AUD", "name": "AUD" }, { "id": "AWG", "name": "AWG" }, { "id": "AZN", "name": "AZN" }, { "id": "BAM", "name": "BAM" }, { "id": "BBD", "name": "BBD" }, { "id": "BDT", "name": "BDT" }, { "id": "BGN", "name": "BGN" }, { "id": "BHD", "name": "BHD" }, { "id": "BIF", "name": "BIF" }, { "id": "BMD", "name": "BMD" }, { "id": "BND", "name": "BND" }, { "id": "BOB", "name": "BOB" }, { "id": "BOV", "name": "BOV" }, { "id": "BRL", "name": "BRL" }, { "id": "BSD", "name": "BSD" }, { "id": "BTN", "name": "BTN" }, { "id": "BWP", "name": "BWP" }, { "id": "BYR", "name": "BYR" }, { "id": "BZD", "name": "BZD" }, { "id": "CAD", "name": "CAD" }, { "id": "CDF", "name": "CDF" }, { "id": "CHE", "name": "CHE" }, { "id": "CHF", "name": "CHF" }, { "id": "CHW", "name": "CHW" }, { "id": "CLF", "name": "CLF" }, { "id": "CLP", "name": "CLP" }, { "id": "CNY", "name": "CNY" }, { "id": "COP", "name": "COP" }, { "id": "COU", "name": "COU" }, { "id": "CRC", "name": "CRC" }, { "id": "CUC", "name": "CUC" }, { "id": "CUP", "name": "CUP" }, { "id": "CVE", "name": "CVE" }, { "id": "CZK", "name": "CZK" }, { "id": "DJF", "name": "DJF" }, { "id": "DKK", "name": "DKK" }, { "id": "DOP", "name": "DOP" }, { "id": "DZD", "name": "DZD" }, { "id": "EGP", "name": "EGP" }, { "id": "ERN", "name": "ERN" }, { "id": "ETB", "name": "ETB" }, { "id": "EUR", "name": "EUR" }, { "id": "FJD", "name": "FJD" }, { "id": "FKP", "name": "FKP" }, { "id": "GBP", "name": "GBP" }, { "id": "GEL", "name": "GEL" }, { "id": "GHS", "name": "GHS" }, { "id": "GIP", "name": "GIP" }, { "id": "GMD", "name": "GMD" }, { "id": "GNF", "name": "GNF" }, { "id": "GTQ", "name": "GTQ" }, { "id": "GYD", "name": "GYD" }, { "id": "HKD", "name": "HKD" }, { "id": "HNL", "name": "HNL" }, { "id": "HRK", "name": "HRK" }, { "id": "HTG", "name": "HTG" }, { "id": "HUF", "name": "HUF" }, { "id": "IDR", "name": "IDR" }, { "id": "INR", "name": "INR" }, { "id": "IQD", "name": "IQD" }, { "id": "IRR", "name": "IRR" }, { "id": "ISK", "name": "ISK" }, { "id": "JMD", "name": "JMD" }, { "id": "JOD", "name": "JOD" }, { "id": "JPY", "name": "JPY" }, { "id": "KES", "name": "KES" }, { "id": "KGS", "name": "KGS" }, { "id": "KHR", "name": "KHR" }, { "id": "KMF", "name": "KMF" }, { "id": "KPW", "name": "KPW" }, { "id": "KRW", "name": "KRW" }, { "id": "KWD", "name": "KWD" }, { "id": "KYD", "name": "KYD" }, { "id": "KZT", "name": "KZT" }, { "id": "LAK", "name": "LAK" }, { "id": "LBP", "name": "LBP" }, { "id": "LKR", "name": "LKR" }, { "id": "LRD", "name": "LRD" }, { "id": "LSL", "name": "LSL" }, { "id": "LTL", "name": "LTL" }, { "id": "LVL", "name": "LVL" }, { "id": "LYD", "name": "LYD" }, { "id": "MAD", "name": "MAD" }, { "id": "MDL", "name": "MDL" }, { "id": "MGA", "name": "MGA" }, { "id": "MKD", "name": "MKD" }, { "id": "MMK", "name": "MMK" }, { "id": "MNT", "name": "MNT" }, { "id": "MOP", "name": "MOP" }, { "id": "MRO", "name": "MRO" }, { "id": "MUR", "name": "MUR" }, { "id": "MVR", "name": "MVR" }, { "id": "MWK", "name": "MWK" }, { "id": "MXN", "name": "MXN" }, { "id": "MXV", "name": "MXV" }, { "id": "MYR", "name": "MYR" }, { "id": "MZN", "name": "MZN" }, { "id": "NAD", "name": "NAD" }, { "id": "NGN", "name": "NGN" }, { "id": "NIO", "name": "NIO" }, { "id": "NOK", "name": "NOK" }, { "id": "NPR", "name": "NPR" }, { "id": "NZD", "name": "NZD" }, { "id": "OMR", "name": "OMR" }, { "id": "PAB", "name": "PAB" }, { "id": "PEN", "name": "PEN" }, { "id": "PGK", "name": "PGK" }, { "id": "PHP", "name": "PHP" }, { "id": "PKR", "name": "PKR" }, { "id": "PLN", "name": "PLN" }, { "id": "PYG", "name": "PYG" }, { "id": "QAR", "name": "QAR" }, { "id": "RON", "name": "RON" }, { "id": "RSD", "name": "RSD" }, { "id": "RUB", "name": "RUB" }, { "id": "RWF", "name": "RWF" }, { "id": "SAR", "name": "SAR" }, { "id": "SBD", "name": "SBD" }, { "id": "SCR", "name": "SCR" }, { "id": "SDG", "name": "SDG" }, { "id": "SEK", "name": "SEK" }, { "id": "SGD", "name": "SGD" }, { "id": "SHP", "name": "SHP" }, { "id": "SLL", "name": "SLL" }, { "id": "SOS", "name": "SOS" }, { "id": "SRD", "name": "SRD" }, { "id": "SSP", "name": "SSP" }, { "id": "STD", "name": "STD" }, { "id": "SYP", "name": "SYP" }, { "id": "SZL", "name": "SZL" }, { "id": "THB", "name": "THB" }, { "id": "TJS", "name": "TJS" }, { "id": "TMT", "name": "TMT" }, { "id": "TND", "name": "TND" }, { "id": "TOP", "name": "TOP" }, { "id": "TRY", "name": "TRY" }, { "id": "TTD", "name": "TTD" }, { "id": "TWD", "name": "TWD" }, { "id": "TZS", "name": "TZS" }, { "id": "UAH", "name": "UAH" }, { "id": "UGX", "name": "UGX" }, { "id": "USD", "name": "USD" }, { "id": "USN", "name": "USN" }, { "id": "USS", "name": "USS" }, { "id": "UYI", "name": "UYI" }, { "id": "UYU", "name": "UYU" }, { "id": "UZS", "name": "UZS" }, { "id": "VEF", "name": "VEF" }, { "id": "VND", "name": "VND" }, { "id": "VUV", "name": "VUV" }, { "id": "WST", "name": "WST" }, { "id": "XAF", "name": "XAF" }, { "id": "XAG", "name": "XAG" }, { "id": "XAU", "name": "XAU" }, { "id": "XBA", "name": "XBA" }, { "id": "XBB", "name": "XBB" }, { "id": "XBC", "name": "XBC" }, { "id": "XBD", "name": "XBD" }, { "id": "XCD", "name": "XCD" }, { "id": "XDR", "name": "XDR" }, { "id": "XFU", "name": "XFU" }, { "id": "XOF", "name": "XOF" }, { "id": "XPD", "name": "XPD" }, { "id": "XPF", "name": "XPF" }, { "id": "XPT", "name": "XPT" }, { "id": "XTS", "name": "XTS" }, { "id": "XXX", "name": "XXX" }, { "id": "YER", "name": "YER" }, { "id": "ZAR", "name": "ZAR" }, { "id": "ZMW", "name": "ZMW" }];
}
export function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
export async function track(page, event, value = '', startSession = false) {
  if (AppConfig.interactionTrackerEnabled) {
    if (startSession || !localStorage.getItem('track-session'))
      localStorage.setItem('track-session', (+new Date) + parseInt(Math.random() * 1000000))//+new Data returns timestamp
    try {
      //console.log({ page, event, value, session_id: localStorage.getItem('track-session') });
      await DataApi.create('track-interactions', { page, event, value, session_id: localStorage.getItem('track-session') });
    } catch (e) {

    }
  }
}
export function getRoles() {
  return GlobalStore.state.auth.user.roles;
}
export function hasAnyRole(roles) {
  return roles.filter(i => getRoles().indexOf(i) !== -1).length > 0
}
export function getAdminRoles() {
  return ['admin', 'super-admin', 'mentorship-manager',
    'blog-manager', 'communications-manager', 'campaigns-manager',
    'accounting-manager', 'funds-manager', 'blog-editor', 'blog-translator'];
}
export function consumePreferredRoute(role) {
  const redirectTo = localStorage.getItem('pref-route');
  if (!redirectTo) return null;
  localStorage.removeItem('pref-route');

  if (redirectTo.indexOf('http') === 0) return redirectTo;
  if (redirectTo[0] !== '/') return null;

  if (
    redirectTo === '/login'
    || redirectTo === '/logout'
    || redirectTo === '/register'
    || redirectTo === '/donor/register'
    || redirectTo === '/choose-role'
    || redirectTo.indexOf('/social-login/') === 0
  ) return null;

  const isAdmin = getAdminRoles().indexOf(role) !== -1;
  if (!isAdmin && redirectTo.indexOf('/admin') === 0) return null;
  return redirectTo;
}
export function isOnMobile() {
  return window.innerWidth <= 600;
}
export function updateFormFieldsVisibility(fields, show, hide) {
  fields = _.cloneDeep(fields);
  fields.forEach((element, key) => {
    if (show && show.indexOf(element.name) !== -1)
      fields[key].hidden = false;
    if (hide && hide.indexOf(element.name) !== -1)
      fields[key].hidden = false;
  });
  return fields;
};
/*
-----------------------------------------------------------------------
Private Functions
-----------------------------------------------------------------------
*/
function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}
